import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProfileMenuComponent } from '../profile-menu/profile-menu.component';

/**
 * A `@mention` inside rendered thread text.
 *
 * Registered for the `mec-social-profile-link` selector in `app.config.ts`,
 * replacing the library's own component for this app: that one navigates to a
 * standalone participant page, and the mention should open the same popover a
 * name or avatar opens everywhere else.
 *
 * `data` is how `DynamicHTMLRendererService` hands over the element's
 * attributes (`label`, `id`), camel-cased -- not an `@Input()` binding, so the
 * shape is whatever `NetworkConstants.patterns` wrote into the HTML.
 */
@Component({
  selector: 'app-mention-link',
  standalone: true,
  imports: [ProfileMenuComponent],
  template: `
    <app-profile-menu [profileId]="data?.id">
      <a class="mention-link">{{ data?.label }}</a>
    </app-profile-menu>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: inline;
      }

      .mention-link {
        color: var(--mep-color-primary);
        font-weight: 600;
        cursor: pointer;
      }

      .mention-link:hover {
        text-decoration: underline;
      }
    `,
  ],
})
export class MentionLinkComponent {
  @Input() public data: { label?: string; id?: string };
}
